// src/utils/stringUtils.js
export function escapeRegExp(string) {
  if (typeof string !== 'string') {
    console.warn("escapeRegExp called with non-string value:", string);
    return ''; // Return empty string for non-string inputs
  }
  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
}
